"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../utils/constants");
var muiWallet16 = {
    paths: [
        {
            path: 'M14,1 L14,5 L14.9991283,5 C15.5518945,5 16,5.44483697 16,5.9955775 L16,15.0044225 C16,15.5542648 15.5553691,16 14.9991283,16 L1.00087166,16 C0.448105505,16 -4.83554169e-17,15.555163 -4.83554169e-17,15.0044225 L-4.83554169e-17,5.9955775 C-4.83554169e-17,5.93412875 0.00555327896,5.87398025 0.0161950045,5.81560887 C-0.0626809871,5.38335643 0.124586105,4.90254842 0.639600721,4.7035655 L12.6396007,0.0672018656 C13.2948236,-0.185952428 14,0.297572698 14,1 Z M12,2.45840695 L5.9988583,4.99905806 L12,4.99905806 L12,2.45840695 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Wallet',
    width: 16,
    height: 16,
};
var muiWallet24 = {
    paths: [
        {
            path: 'M18,1.50090475 L17.9998984,6.5 L20.9975383,6.50090475 C21.5511826,6.50090475 22,6.94982495 22,7.50838872 L22,20.4934208 C22,21.0498388 21.5605417,21.5009047 20.9975383,21.5009047 L1.00246167,21.5009047 C0.448817378,21.5009047 1.0658141e-14,21.0519845 1.0658141e-14,20.4934208 L0.000317102886,7.54392988 C-0.0187110581,7.17648799 0.153091546,6.79924004 0.550956546,6.60647679 C0.588369723,6.58782895 0.626835783,6.57149117 0.666512512,6.55756419 L16.6488766,0.56457557 C17.3026274,0.319419012 18,0.802698563 18,1.50090475 Z M16,2.94390522 L6.51466792,6.50090475 L16,6.50090475 L16,2.94390522 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Wallet',
    width: 22,
    height: 22,
};
var muiWallet = {
    base: muiWallet16,
    smIcon: muiWallet16,
    lgIcon: muiWallet24,
};
exports.muiWallet = muiWallet;
//# sourceMappingURL=wallet.js.map